export default __webpack_public_path__ + "static/media/ic_burkina_faso.513fc5f6.svg";